import { DEACTIVATE_DENY, ACTIVATE_DENY, CREATE_DENY, UPDATE_DENY, GET_ERRORS, GET_DENIALS } from './types';
import { getErrorMessage } from '../utils/util.errors';
import services from '../config/services';
import axios from 'axios';

const URL_GET_DENIALS     = process.env.REACT_APP_API_URL + services.getDenyByFilters;
const URL_DEACTIVATE_DENY = process.env.REACT_APP_API_URL + services.deactivateDeny;
const URL_ACTIVATE_DENY   = process.env.REACT_APP_API_URL + services.activateDeny;
const URL_UPDATE_DENY     = process.env.REACT_APP_API_URL + services.updateDeny;
const URL_CREATE_DENY     = process.env.REACT_APP_API_URL + services.addDeny;

export const getDenials = (params = null) => dispatch => {
	let url = URL_GET_DENIALS;
	if(params){
		if(params.hasOwnProperty('is_active')){
			url += '?is_active=' + params.is_active;
		}
	}

	axios
		.get(url)
		.then(res => {
			dispatch({
				type: GET_DENIALS,
				payload: {
					message: res.data.result
				}
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};

export const createDeny = (deny) => dispatch => {

	axios.post(URL_CREATE_DENY, deny)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type: CREATE_DENY,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)

			})
		});
}

export const updateDeny = (deny) => dispatch => {

	axios.patch(URL_UPDATE_DENY, deny)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type: UPDATE_DENY,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const activateDeny = (id) => dispatch => {
	let url = URL_ACTIVATE_DENY + id;

	axios.patch(url)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type: ACTIVATE_DENY,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const deactivateDeny = (id) => dispatch => {
	axios
		.delete(URL_DEACTIVATE_DENY + id)
		.then(res => {
			dispatch({
				type: DEACTIVATE_DENY,
				payload: res.data
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};